module.exports = __webpack_public_path__ + "img/pay_date.c6df6045.svg";